export default {
  id: 'variousCredit',
  idHr: 'CV',
  url: 'various-credit',
  title: 'LOANS.LOANS_CATALOG.CARDS.VARIOUS_CREDIT',
  titleSecondary: 'LOANS.LOANS_CATALOG.CARDS.VARIOUS_CREDIT_2',
  img: 'img/loans/loans-catalog/various.png',
  header: 'img/loans/loans-catalog/various-header.png',
  minMonthlyFeeDivider: 84,
  signUp: {
    deadline: 84,
    interestRate: 0,
    annualPercentageRate: 0,
    mandatoryInsurance: false,
    tooltipId: 'VARIOUS_CREDIT',
  },
  detail: {
    title: 'LOANS.LOANS_CATALOG.CARDS.VARIOUS_CREDIT',
    basicCharacteristics: [
      {
        title: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.TITLE1',
        desc: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG1',
      },
      {
        title: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.TITLE2',
        desc: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG2',
      },
      {
        title: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.TITLE3',
        desc: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG3',
        typeInterest: [
          {
            formula: {
              title: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG3_FORMULA_TEXT',
              nominator: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG3_FORMULA_2',
            },
            table: {
              paragraph: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG3_TEXT',
              titleTable: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG3_TEXT_TABLE',
            },
          },
        ],
        textToCatalog: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG3_FORMULA_TEXT',
      },
      {
        title: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.TITLE7',
        desc: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG7',
      },
      {
        title: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.TITLE4',
        desc: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG4',
      },
      {
        title: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.TITLE5',
        desc: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG5',
      },
      {
        title: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.TITLE6',
        desc: [
          'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG6_1',
          'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.BASIC_CHARACTERISTICS.MSG6_2',
        ],
      },
    ],
    requestIt: [
      {
        items: [
          {
            text: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.REQUEST_IT.PARAGRAPH1.ITEM1_TEXT1',
            link: 'my-creditworthiness',
            textLink: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.REQUEST_IT.PARAGRAPH1.ITEM1_TEXTLINK',
          },
          {
            text: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.REQUEST_IT.PARAGRAPH1.ITEM2_TEXT1',
            link: 'sign-up',
            textLink: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.REQUEST_IT.PARAGRAPH1.ITEM2_TEXTLINK',
          },
          {
            text: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.REQUEST_IT.PARAGRAPH1.ITEM3_TEXT1',
            link: 'need-a-loan',
            textLink: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.REQUEST_IT.PARAGRAPH1.ITEM3_TEXTLINK',
          },
        ],
        otherItems: [
          {
            text: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.REQUEST_IT.PARAGRAPH2.ITEM1_TEXT',
          },
          {
            text: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.REQUEST_IT.PARAGRAPH2.ITEM2_TEXT',
            items: [
              'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.REQUEST_IT.PARAGRAPH2.ITEM2_LIST1',
              'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.REQUEST_IT.PARAGRAPH2.ITEM2_LIST2',
            ],
          },
          {
            text: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.REQUEST_IT.PARAGRAPH2.ITEM3_TEXT',
            link: 'my-loans',
            textLink: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.REQUEST_IT.PARAGRAPH2.ITEM3_TEXTLINK',
          },
        ],
      },
    ],
    prepayments: [
      {
        text: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.PREPAYMENTS.PARAGRAPH1',
        link: 'my-loans',
        textLink: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.PREPAYMENTS.PARAGRAPH1_TEXTLINK',
        text2: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.PREPAYMENTS.PARAGRAPH1_1',
      },
      {
        text: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.PREPAYMENTS.PARAGRAPH2',
      },
    ],
    sendDocumentation: [
      {
        text: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.SEND_DOCUMENTATION.PARAGRAPH1',
        textLink: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.SEND_DOCUMENTATION.PARAGRAPH1_TEXTLINK',
        link: 'https://bbvatyc.service-now.com/tyc?id=bbva_hrj_sc_cat_item&sys_id=1693fa2397204e5022b836b3f153af20',
        text2: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.SEND_DOCUMENTATION.PARAGRAPH1_2',
      },
      {
        text: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.SEND_DOCUMENTATION.PARAGRAPH2',
      },
      {
        text: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.SEND_DOCUMENTATION.PARAGRAPH3',
      },
      {
        text: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.SEND_DOCUMENTATION.PARAGRAPH4',
      },
      {
        text: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.SEND_DOCUMENTATION.PARAGRAPH5',
        textLink: 'KB0024654',
        link: 'https://bbvatyc.service-now.com/saeesp?id=bbva_kb_article&sys_id=834144ebdb286f00a6148c994b96192c'
      },
    ],
    finishDeadline: 'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.FINISH_DEADLINE',
    statementIncome: [
      'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.STATEMENT_INCOME.PARAGRAPH1',
      'LOANS.LOANS_DETAIL.VARIOUS_CREDIT.STATEMENT_INCOME.PARAGRAPH2',
    ],
  },
  legalConditions: {
    clause: {
      title: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.TITLE',
      paragraph: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.PARAGRAPH',
      items: [
        'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM1',
        'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM2',
        'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM3',
        'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CLAUSE.ITEM4',
      ],
    },
    declaration: {
      title: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.TITLE',
      paragraph: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH',
      items: [
        'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.ITEM1',
        'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.ITEM2',
        'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.ITEM3',
        'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.ITEM4',
        'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.ITEM5',
      ],
      info: [
        {
          text: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO',
          items: [
            'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO_ITEM1',
            'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO_ITEM2',
            'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO_ITEM3',
            'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO_ITEM4',
          ],
        },
        {
          text: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2',
          items: [
            'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM1',
            'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM2',
            'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM3',
            'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM4',
            'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM5',
            'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.CV_5S_9S.DECLARATION.INFO2_ITEM6',
          ],
        },
      ],
      authorization: {
        paragraph: 'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH2',
        items: [
          'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH2_ITEM1',
          'LOANS.SIGN_UP.LEGAL_CONDITIONS.DETAILS.DECLARATION.PARAGRAPH2_ITEM2',
        ],
      },
    },
  },
};



// WEBPACK FOOTER //
// ./client/app/loans.module/common/services/static/variousCredit.js